export const enum StatsTealiumCollectTypeEnum {
  view = 'view',
  link = 'link',
  track = 'track',
}
